import React from 'react';
import { Content, Header, Page, Table, TableColumn } from "@backstage/core-components";
import { Link } from "@material-ui/core";;

interface TestData {
    name: string
    owner: string
    link: string
    description: string
}
const data = [
    {
        name: "PIM (Product Information Management)",
        owner: "Product-Group",
        link: "https://customersolution-uaepim.mafrservicesstg.com/",
        description: "Centralizes and manages product data, streamlining the process of enriching and distributing accurate product information across various sales channels."
    },
    {
        name: "Supplier Portal",
        owner: "Product-Group",
        link: "https://supplier.carrefouruae.com/",
        description: "Empowers suppliers and third-party sellers to easily onboard, manage listings, track sales, and fulfill orders, expanding the retailer�s product offerings without increasing inventory."
    },
    {
        name: "Marketplace Portal",
        owner: "Product-Group",
        link: "https://customersolution-uaemkp.mafrservicesstg.com/login",
        description: "A Marketplace Portal allows sellers to register, list products, and sell to customers. Sellers can either fulfill orders themselves or use Carrefour's Last Mile Solution for delivery, ensuring seamless transactions and efficient delivery."
    },
    {
        name: "CMS (Content Management Service)",
        owner: "Product-Group",
        link: "https://retail-platform.mafrservicesstg.com/app/cms/dashboard",
        description: "A flexible content management system that supports the creation, modification, and distribution of rich, engaging content across the platform, allowing for seamless content updates and personalization."
    }
]
export const AppsTable = () => {
    const columns: TableColumn[] = [
        {
            title: 'Name',
            field: 'name',
            highlight: true,
            render: (row: Partial<TestData>) => (
                row.link ?
                    (<Link href={row.link}>{row.name}</Link>) :
                    (<Link href='#'>{row.name}</Link>)
            ),
        },
        {
            title: 'Owner',
            field: 'owner',
        },
        {
            title: 'Description',
            field: 'description',
        }
    ];

    return (
        <Page themeId="home">
      <Header title="MAF Apps" pageTitleOverride="Home">
      </Header>
      <Content>
            <Table
                options={{ paging: false }}
                data={data}
                columns={columns}
                title="Apps"
            />
        </Content>
        </Page>
    );
};